// extracted by mini-css-extract-plugin
export default {"container":"fullScreenLoader__container__Dh3nY","show":"fullScreenLoader__show__redQG","ticket":"fullScreenLoader__ticket__wzDLH","slowSpin":"fullScreenLoader__slowSpin__f21zz"};